import { Layer } from 'ui/components/Layer'
import { Page, PageFace } from 'ui/components/Page'

import { Actions } from './components/Actions'
import { AdverseMediaListTable } from './components/AdverseMediaListTable'
import { Filter } from './components/Filter'
import { useAdverseMediaListContext } from './context/AdverseMediaListContext'
import { AdverseMediaListContextProvider } from './context/AdverseMediaListContextProvider'

const Wrapper = () => {
  const { isFirstLoading } = useAdverseMediaListContext()
  return (
    <Page face={PageFace.PRIMARY} title="Adverse Media" actions={<Actions />} isPending={isFirstLoading}>
      <Layer rounded shadowed>
        <Filter />
        <AdverseMediaListTable />
      </Layer>
    </Page>
  )
}

const List = () => (
  <AdverseMediaListContextProvider>
    <Wrapper />
  </AdverseMediaListContextProvider>
)

export default List
